<template>
  <v-autocomplete
    dense
    height="25px"
    :value="value"
    @input="value => $emit('input', value)"
    :items="timezones"
    v-bind="[$props, $attrs]"
    label="Timezone">
    <template #label v-if="typeof $attrs.required !== 'undefined'">
      Timezone <span class="red--text pl-1">*</span>
    </template>
  </v-autocomplete>
</template>

<script>
/**
 * Timezone Select
 * @displayName Timezone Select
 */
export default {
  props: {
    /**
     * @model
     */
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    timezones: []
  }),
  mounted() {
    this.timezones = this.novaCore.getSupportedTimezones();
  }
};
</script>
